import React from 'react';
import {Popover, OverlayTrigger} from 'react-bootstrap';

export default function reInfoDialog({
  placement,
  title,
  description,
  screenshot,
  trigger,
  customizeId,
  children,
  popoverMaxWidth,
}) {
  if (screenshot) {
    return (
      <OverlayTrigger
        trigger={trigger}
        placement={placement}
        rootClose={true}
        style={{cursor: 'help'}}
        overlay={
          <Popover
            key="confirmation"
            id={customizeId || 'confirmation'}
            title={title}
            style={{maxWidth: popoverMaxWidth}}
          >
            <Popover.Header>{title}</Popover.Header>
            <Popover.Body>
              <span>
                <div>{description}</div>
                <div className={screenshot} style={{margin: '0 auto'}} />
              </span>
            </Popover.Body>
          </Popover>
        }
      >
        {children}
      </OverlayTrigger>
    );
  } else {
    return (
      <OverlayTrigger
        trigger={trigger}
        style={{cursor: 'help'}}
        placement={placement}
        rootClose={true}
        overlay={
          <Popover
            key="confirmation"
            id={customizeId || 'confirmation'}
            style={{maxWidth: popoverMaxWidth && popoverMaxWidth}}
          >
            <Popover.Header>{title}</Popover.Header>
            <Popover.Body>{description}</Popover.Body>
          </Popover>
        }
      >
        {children}
      </OverlayTrigger>
    );
  }
}
